
type projectType = {
    'title':string
    'desc':string
    'date':string
    'color':string
    'read_time':string
    'category':string
    'image':string
    'link':string
}

export const projects : projectType[] = [
    {
        'title':'AirFlow ETL : Tokopedia WebScrapping', 
        'desc': '1st Place Winner Data Academy Final Project. ETL Data Pipeline with optional Google Cloud Solution', 
        'date': 'Dec 22, 2023',
        'color':'yellow-300',
        'read_time':'6 min',
        'category':'Data Engineering',
        'image':'promag-logo.jpeg',
        'link':'https://github.com/Jonathanjordan21/airflow_promag'
    },{
        'title':'Calendivity : Mobile Apps powered by Machine Learning', 
        'desc': 'Bangkit Academy 2023 Final Project. Mobile Apps to predict difficulty of activities based on user profile', 
        'date': 'Jun 18, 2023',
        'color':'neutral-200',
        'read_time':'10 min',
        'category':'Data Science',
        'image':'https://github.com/Calendivity/Calendivity-ML/raw/main/media/atus.png',
        'link':'https://github.com/Calendivity/Calendivity-ML'
    },{
        'title':'WaveUNet : Audio Source Separation', 
        'desc': 'State-Of-The-Art (SOTA) Audio Source Separation deep learning model trained on MUSDB dataset', 
        'date': 'Dec 22, 2023',
        'color':'neutral-200',
        'read_time':'6 min',
        'category':'Deep Learning',
        'image':'https://github.com/Jonathanjordan21/Audio-Source-Separation/raw/main/media/waveunet.png',
        'link':'https://github.com/Jonathanjordan21/Audio-Source-Separation'
    },{
        'title':"Customized Indonesian Video Content Generator with AI", 
        'desc': 'Artificial Intelligence to generate a short video content based on text (story) input', 
        'date': 'Ongoing',
        'color':'blue-400',
        'read_time':'5 min',
        'category':'Artificial Intelligence',
        'image':'AI_generated_logo.jpg',
        'link':'https://huggingface.co/spaces/jonathanjordan21/Content-Generator'
    },{
        'title':"Nutritional & Supplement Facts Detector", 
        'desc': 'OCR-Free Document Understanding Transformer Finetuned on Indonesian Nutritional & Supplement Facts dataset', 
        'date': 'Dec 22, 2023',
        'color':'blue-400',
        'read_time':'3 min',
        'category':'Artificial Intelligence',
        'image':'lays_kuning_generated.jpg',
        'link':'https://huggingface.co/spaces/jonathanjordan21/food-nutritional-facts-detection-donut'
    },{
        'title':"EasySale", 
        'desc': '2nd Place Winner KOMPRES 14 -Community Based- Apps. Mobile app for accounting with statistical dashboards and automatic pdf report generator', 
        'date': 'Dec 22, 2023',
        'color':'yellow-200',
        'read_time':'6 min',
        'category':'Mobile Development',
        'image':'easy_sale.jpeg',
        'link':'https://github.com/Jonathanjordan21/EasySale'
    }
    
]